export { ModalManager as default } from 'choerodon-ui/shared';
